import { Body2, Button, Heading3, Heading4 } from '@cian/ui-kit';
import cn from 'clsx';
import React from 'react';
import { BanksLogoList } from 'shared/components/BanksLogoList';
import { ContainerInner } from 'shared/components/ContainerInner';
import { NBSP } from 'shared/constants/common';
import { ETestIds } from 'shared/constants/testIds';

import * as styles from '../styles.css';
import { TRedesignStickyBarVariant } from '../utils/resolveStickyBarVariant';

export interface IRedesignStickyBarContentProps {
  variant: TRedesignStickyBarVariant;
  paymentText?: string | null;
  rateText?: string | null;
  bankLogos?: string[];
  onInfoClick: () => void;
  onCtaClick: () => void;
  isCtaLoading?: boolean;
}

export const RedesignStickyBarContent: React.FC<IRedesignStickyBarContentProps> = ({
  variant,
  paymentText,
  rateText,
  bankLogos = [],
  onInfoClick,
  onCtaClick,
  isCtaLoading,
}) => {
  const isInfoVisible = variant === 'info' || variant === 'info-empty';
  const isCtaVisible = variant === 'cta';
  const isEmpty = variant === 'info-empty';
  const showBankLogos = variant === 'info' && bankLogos.length > 0;

  return (
    <div className={styles['root']} data-testid={ETestIds.RedesignStickyBar}>
      <div
        className={cn(styles['bar'], styles['bar--info'], isInfoVisible && styles['bar--visible'])}
        data-testid={ETestIds.RedesignStickyInfoBar}
        aria-hidden={!isInfoVisible}
      >
        <ContainerInner>
          <button
            type="button"
            className={cn(styles['info-button'], isEmpty && styles['info-button--empty'])}
            onClick={onInfoClick}
          >
            <div className={styles['info-content']}>
              {isEmpty ? (
                <>
                  <Heading4 fontWeight="700">Нет подходящих предложений</Heading4>
                  <Body2 color="text-secondary-default">Измените срок кредита или первый взнос</Body2>
                </>
              ) : (
                <>
                  {paymentText && <Heading3 fontWeight="700">{paymentText}</Heading3>}
                  {rateText && <Body2>{rateText}</Body2>}
                </>
              )}
            </div>
            {showBankLogos && (
              <div className={styles['info-logos']}>
                <BanksLogoList banks={bankLogos} size="S" maxLogosShown={5} />
              </div>
            )}
          </button>
        </ContainerInner>
      </div>

      <div
        className={cn(styles['bar'], styles['bar--cta'], isCtaVisible && styles['bar--visible'])}
        data-testid={ETestIds.RedesignStickyCtaBar}
        aria-hidden={!isCtaVisible}
      >
        <ContainerInner>
          <div className={styles['cta-content']}>
            <Button
              size="L"
              fullWidth
              loading={isCtaLoading}
              onClick={onCtaClick}
              data-testid={ETestIds.FillApplicationButtonStickyCta}
            >
              Заполнить анкету на Циане
            </Button>
            <Body2 color="text-secondary-default" textAlign="center">
              {`Анкета${NBSP}— единая для всех банков`}
            </Body2>
          </div>
        </ContainerInner>
      </div>
    </div>
  );
};
